<template>
  <div></div>
</template>

<script lang="ts">
import { defineComponent, onUnmounted } from 'vue';
import { snackbarType } from '@/types/common';
import iconClose from '@/components/icons/iconClose.vue';
import { useQuasar } from 'quasar';

const initState = (): snackbarType => ({
  message: '',
  type: 'negative',
});

export default defineComponent({
  name: 'SnackbarComponent',
  components: {
    iconClose,
    useQuasar,
  },

  setup() {
    const $q = useQuasar();

    const showSnackbar = (evt) => {
      const params = Object.assign(initState(), evt.detail);
      $q.notify({
        type: params.type,
        message: params.message,
      });
    };

    window.addEventListener('ShowSnackbar', showSnackbar, true);

    onUnmounted(() => {
      window.removeEventListener('ShowSnackbar', showSnackbar, true);
    });

    return {};
  },
});
</script>
